import { Swappable } from '@shopify/draggable'

window.Dropzone = require('dropzone')
window.Dropzone.autoDiscover = false

window.Dropzone.prototype.defaultOptions.dictDefaultMessage = "Zde vložte vaše obrázky. <br/>Pokud nejdou přidat, zkuste zmenšit jejich velikost";
window.Dropzone.prototype.defaultOptions.dictFallbackMessage = "Váš prohlížeč nepodporuje nahrávání souborů drag'n'drop.";
window.Dropzone.prototype.defaultOptions.dictFileTooBig = "Soubor je příliš velký ({{filesize}}MiB). Maximální povolená velikost je: {{maxFilesize}}MiB.";
window.Dropzone.prototype.defaultOptions.dictInvalidFileType = "Tento typ souboru není podporován.";
window.Dropzone.prototype.defaultOptions.dictCancelUpload = "Zrušit";
window.Dropzone.prototype.defaultOptions.dictCancelUploadConfirmation = "Opravdu chcete zrušit nahrávání?";
window.Dropzone.prototype.defaultOptions.dictRemoveFile = "Odebrat";
window.Dropzone.prototype.defaultOptions.dictMaxFilesExceeded = "Nelze nahrát více souborů.";

$(function () {
  if ($('#product-dropzone').length === 0) return

  let swappable = null
  let swappingTimeout = -1

  const addImagesToDropzone = (images, dz) => {
    if (!_.isArray(images)) return

    images.forEach((image) => {
      let mockFile = { name: 'Filename', dataURL: image.file }

      dz.files.push(mockFile)
      dz.emit('addedfile', mockFile)
      dz.createThumbnailFromUrl(
        mockFile,
        dz.options.thumbnailWidth,
        dz.options.thumbnailHeight,
        dz.options.thumbnailMethod,
        true,
        (thumbnail) => {
          dz.emit('thumbnail', mockFile, thumbnail)
        }
      )

      const previews = document.getElementsByClassName('dz-preview')
      previews[previews.length - 1].setAttribute('data-image', image.id)
      previews[previews.length - 1].setAttribute('data-local', 1)

      if (image.is_primary) {
        previews[previews.length - 1].classList.add('dz-image-main')
      }

      dz.emit('complete', mockFile)
    })

    if ($('.dz-image-main').length === 0) {
      $('.dz-preview')
        .first()
        .addClass('dz-image-main')
    }
  }

  const rebuildSwappable = () => {
    swappable && swappable.destroy()
    swappable = new Swappable(
      document.querySelectorAll('.dz-preview'),
      {
        draggable: '.dz-preview',
        delay: 300
      }
    )

    swappable.on('swappable:stop', () => {
      clearTimeout(swappingTimeout)
      swappingTimeout = setTimeout(() => {
        const ids = []

        for (let item of document
          .getElementById('product-dropzone')
          .getElementsByClassName('dz-preview')) {
          ids.push(item.getAttribute('data-image'))
        }

        axios.post('/images/update-order', {
          order: ids.filter((v, i, a) => a.indexOf(v) === i)
        })
      }, 2000)
    })
  }

  const dz = new Dropzone('#product-dropzone', {
    url: '/images/process',
    params: {
      product_id: window.product_id || 0
    },
    addRemoveLinks: true,
    acceptedFiles: 'image/*',
    parallelUploads: 1,
    maxFilesize: 8,
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
    init() {
      addImagesToDropzone(window.images, this)
    },
    success(file, response) {
      file.previewElement.setAttribute('data-image', response.id)

      if ($('.dz-image-main').length === 0) {
        file.previewElement.classList.add('dz-image-main')

        axios.get('/images/' + response.id + '/select')
      }
    },
    removedfile(file) {
      file.previewElement.remove()

      axios.delete('/images/' + file.previewElement.getAttribute('data-image') + '/delete')
    }
  })

  dz.on("thumbnail", function (file) {
    rebuildSwappable()
  });

  $('#product-dropzone').on('click', '.dz-preview', function () {
    $('.dz-preview').removeClass('dz-image-main')
    const id = $(this).data('image')
    $(this).addClass('dz-image-main')

    axios.get('/images/' + id + '/select')
  })
})
